import { render, staticRenderFns } from "./Kyc.vue?vue&type=template&id=675cf682&scoped=true&"
import script from "./Kyc.vue?vue&type=script&lang=js&"
export * from "./Kyc.vue?vue&type=script&lang=js&"
import style0 from "./Kyc.vue?vue&type=style&index=0&id=675cf682&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675cf682",
  null
  
)

export default component.exports